// extracted by mini-css-extract-plugin
export default {"params":"NOLo__"};